import "slick-carousel";
/**============================================================
*   [top slider]
*   description : 販売新着スライド処理を記述
============================================================*/
document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('js-top-sell__slider')){
    //要素高さ揃え
    var maxH = 0;
    var timerResize = false;
    $('#js-top-sell__slider').on('init', function(event, slick, direction){
      setSlideHeight();
    });
    $(window).on('resize', function(){
      if (timerResize !== false) {
        clearTimeout(timerResize);
      }
      timerResize = setTimeout(function() {
        setSlideHeight();
      }, 100);
    });

    function setSlideHeight(){
      maxH = 0;
      $('.p-article-list__item__box').attr('style','');
      $('.p-article-list__item__box').each(function(){
        if(maxH < $(this).outerHeight()) maxH = $(this).outerHeight();
      })
      $('.p-article-list__item__box').css('height',maxH);
    }

    $('#js-top-sell__slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 600,
      slidesToShow: 4,
      slidesToScroll: 4,
      adaptiveHeight: false,
      prevArrow: '#js-top-sell__slider-prev',
      nextArrow: '#js-top-sell__slider-next',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
          }
        },
      ]
    });
  }
})
